import Button from 'components/button'
import { GridColumn, GridRow } from 'components/grid'
import { pushBanner, useStickyBannerStore } from 'components/sticky-banner/store'
import { defineComponent, onBeforeUnmount, ref } from 'vue'
import { useResponsive } from '~/composables/useResponsive'

type AutoLogoutBannerOptions = {
  durationSeconds: number
  onStayLoggedIn: () => void
  onTimeout: () => void
}

export const pushAutoLogoutBanner = (options: AutoLogoutBannerOptions) => {
  const bannerStore = useStickyBannerStore()

  // Don't push duplicate
  if (bannerStore.stickyBanners['auto-logout-banner']) return

  const CountdownBody = defineComponent(() => {
    const secondsRemaining = ref(options.durationSeconds)
    const { isPhone } = useResponsive()

    const interval = setInterval(() => {
      secondsRemaining.value--
      if (secondsRemaining.value <= 0) {
        clearInterval(interval)
        bannerStore.popBanner('auto-logout-banner')
        options.onTimeout()
      }
    }, 1000)

    onBeforeUnmount(() => {
      clearInterval(interval)
    })

    const handleStayLoggedIn = () => {
      clearInterval(interval)
      bannerStore.popBanner('auto-logout-banner')
      options.onStayLoggedIn()
    }

    return () => (
      <GridRow
        layout={isPhone.value ? '1fr' : 'min-content min-content'}
        gap={isPhone.value ? '0.5rem' : '1rem'}
      >
        <GridColumn justifyItems="center" alignItems="center">
          <div class="whitespace-nowrap font-medium">
            You will be logged out in {secondsRemaining.value}s
          </div>
        </GridColumn>
        <GridColumn justifyItems="center" alignItems="center">
          <Button
            variant="ghostWhite"
            size="s"
            onClick={handleStayLoggedIn}
          >
            <div class="font-semibold">Stay Logged In</div>
          </Button>
        </GridColumn>
      </GridRow>
    )
  })

  pushBanner({
    body: CountdownBody,
    variant: 'warning',
    uid: 'auto-logout-banner'
  })
}
